import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type URLSearchParamsMutator = (params: URLSearchParams) => URLSearchParams;

export const useURLSearchParams = () => {
  const history = useHistory();
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const onChange = (mutator: URLSearchParamsMutator) => {
    const changes = new URLSearchParams(params);
    mutator(changes);
    history.push({
      ...location,
      search: String(changes),
    });
  };

  return [params, onChange] as const;
};
